export default "__VITE_ASSET__dRiUmxn5__"